import { render, staticRenderFns } from "./Satari.vue?vue&type=template&id=1661acbc"
import script from "./Satari.vue?vue&type=script&lang=js"
export * from "./Satari.vue?vue&type=script&lang=js"
import style0 from "./Satari.vue?vue&type=style&index=0&id=1661acbc&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports